import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle, Sparkles } from 'lucide-react';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';

export default function SubscriptionSuccess() {
  const navigate = useNavigate();
  const { theme } = useTheme();
  const { user } = useAuth();

  useEffect(() => {
    // Auto-redirect after 5 seconds
    const timer = setTimeout(() => {
      navigate('/player-dashboard');
      // Force page reload to refresh auth state
      window.location.reload();
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ 
      background: theme === 'dark' 
        ? 'linear-gradient(135deg, #0a0e27 0%, #1a1f3a 100%)' 
        : 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)'
    }}>
      <Card className={`glass-card max-w-md w-full mx-4 text-center ${theme === 'light' ? 'bg-white/95' : ''}`}>
        <div className="py-12 px-6">
          <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-gradient-to-br from-green-400 to-emerald-600 flex items-center justify-center">
            <CheckCircle className="w-12 h-12 text-white" />
          </div>
          
          <h1 className={`text-3xl font-bold mb-4 ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`}>
            Welcome to Pro!
          </h1>
          
          <p className={`mb-6 ${theme === 'dark' ? 'text-gray-400' : 'text-gray-600'}`}>
            Your subscription is now active. You've unlocked:
          </p>
          
          <div className="space-y-3 mb-8">
            <div className="flex items-center justify-center space-x-2">
              <Sparkles className="w-5 h-5 text-yellow-400" />
              <span className={theme === 'dark' ? 'text-gray-300' : 'text-gray-700'}>Unlimited journals & videos</span>
            </div>
            <div className="flex items-center justify-center space-x-2">
              <Sparkles className="w-5 h-5 text-yellow-400" />
              <span className={theme === 'dark' ? 'text-gray-300' : 'text-gray-700'}>5 AI video analyses per month</span>
            </div>
            <div className="flex items-center justify-center space-x-2">
              <Sparkles className="w-5 h-5 text-yellow-400" />
              <span className={theme === 'dark' ? 'text-gray-300' : 'text-gray-700'}>Advanced analytics</span>
            </div>
            <div className="flex items-center justify-center space-x-2">
              <Sparkles className="w-5 h-5 text-yellow-400" />
              <span className={theme === 'dark' ? 'text-gray-300' : 'text-gray-700'}>Priority support</span>
            </div>
          </div>
          
          <p className={`text-sm mb-6 ${theme === 'dark' ? 'text-gray-500' : 'text-gray-600'}`}>
            Redirecting to your dashboard in 5 seconds...
          </p>
          
          <Button 
            onClick={() => { navigate('/player-dashboard'); window.location.reload(); }}
            className="bg-gradient-to-r from-purple-500 to-pink-500"
          >
            Go to Dashboard Now
          </Button>
        </div>
      </Card>
    </div>
  );
}
